module.exports = "/cabinet/img/header-logo-mobile.76ecccc2.svg";